var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VFooter',{staticClass:"vd-footer-wrapper",attrs:{"min-height":"64","width":"100%","elevation":"1","color":"#fafafa"}},[_c('VRow',{staticClass:"ma-0",attrs:{"justify":"center"}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }